import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ConfigurationService } from "app/core/services/configuration.service";
import { NotifMessageService } from "app/core/services/notifmessage.service";
import { NGXLogger } from "ngx-logger";
import { KeycloakService } from "security/keycloak.service";

@Component({
  selector: "app-new-header",
  templateUrl: "./header.component.html"
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() toggleSideNav = new EventEmitter<void>();
  
  mobileQuery: MediaQueryList;
  lang: string;
  languages: Array<any>;
  infosUser: any = {};
  environnements: Array<any>;
  selectedEnv: string = 'checkout';
  private _mobileQueryListener: () => void;

  constructor(
    private translateService: TranslateService,
    private keycloakService: KeycloakService,
    private configService: ConfigurationService,
    private notifService: NotifMessageService,
    private log: NGXLogger,
    private router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.environnements = [];
    this.environnements.push({ value: 'checkout', label: 'checkout' });
    this.environnements.push({ value: 'archives', label: 'archives' });
    this.environnements.push({ value: 'IF', label: 'IF' });
    this.mobileQuery = media.matchMedia("(max-width: 800px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener("change", this._mobileQueryListener);
  }

  ngOnInit(): void {
    if (this.keycloakService.isKeyCloakActive()) {
      this.loadUserInfo();
    }
    this.initLanguages();
    this.languages.map((language) => {
      if(language.value === this.translateService.getDefaultLang()) {
        this.lang = language.label;
      }
    });
  }

  initLanguages() {
    this.languages = this.configService.config.languages;
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener("change", this._mobileQueryListener);
  }

  toggleSideNavigation() : void {
    this.toggleSideNav.emit();
  }

  onLangChange(language : string, code : string) {
    this.lang = language;
    this.translateService.use(code);
  }

  login(): void {
    this.keycloakService.login().subscribe(loggedIn => {
        if (loggedIn) {
            this.log.log('logged IN ! Success !');
        } else {
            this.log.log('Not logged in - Login failed !');
        }
    });
  }

  logout(): void {
      this.keycloakService.logout().subscribe(logout => {
          if (logout) {
              this.log.log('log Out : Success !');
          } else {
              this.log.log('Error while log out !');
          }
      });
  }

  isLoggedIn(): boolean {
      return this.keycloakService.isLoggedIn();
  }


  profile(): void {
    this.notifService.emitModalWithDetails("PROFILE", this.infosUser);
  }

  loadUserInfo(): void {
    this.keycloakService.getInfosUser().then((response) => {
        if (response != null && undefined !== response) {
            this.infosUser = response;
            this.infosUser = { ...this.infosUser, roles: this.keycloakService.getRoles() };
        }
    });
 }
}
